import React from 'react';

import { LabelEnum } from 'app/shared/enums';
import { TravelFormSubmitBoxProps } from './TravelFormSubmitBox.interface';
import { BigFormActionButton } from 'app/components/BigFormActionButton';
import { useStyles } from './TravelFormSubmitBox.styles';
import { useTravelForm } from 'app/components/TravelForm/useTravelForm';

export default function TravelFormSubmitBox(props: TravelFormSubmitBoxProps) {
  const classes = useStyles();
  const { submit, isSubmitting } = useTravelForm();

  const onSubmit = () => {
    submit();
  };

  return (
    <>
      <div className={classes.messageTop}>
        <strong>{LabelEnum.TravelMessageForPoland1}</strong>
      </div>
      <BigFormActionButton
        title={LabelEnum.ShowOffersForPoland}
        type={'button'}
        onClick={onSubmit}
        isLoading={isSubmitting}
      />
      <div className={classes.messageBottom}>
        {LabelEnum.TravelMessageForPoland2}
      </div>
    </>
  );
}
